import { useState, useEffect } from 'react';
import { platform } from '../lib/api';

export const useSocialLinks = () => {
  const [socialLinks, setSocialLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSocialLinks = async () => {
      try {
        setLoading(true);
        const result = await platform.getSocialLinks();
        setSocialLinks(result.data || []);
      } catch (err) {
        console.error('Error fetching social links:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSocialLinks();
  }, []);

  return { socialLinks, loading, error };
};
